import Vue from 'vue'

// eslint-disable-next-line
import { Module } from 'vuex'

interface IState
{
	templateIds: Array<string>
	projectsById: {[key: string]: Project}
}

const module: Module<IState, {}> = {
	namespaced: true,

	state: {
		templateIds: [],
		projectsById: {}
	},

	getters: {
		templates: state => {
			return state.templateIds.map(uid => state.projectsById[uid])
		}
	},

	mutations: {
		setTemplateData: (state, data: PublishedTemplate) => {
			const uid = data.uid
			const idx = state.templateIds.findIndex(id => id === uid)
			if (idx >= 0)
			{
				Vue.set(state.templateIds, idx, uid)
			}
			else
			{
				state.templateIds.push(uid)
			}

			Vue.set(state.projectsById, uid, data)
		},

		removeProject: (state, data: PublishedTemplate) => {
			const uid = data.uid

			const idx = state.templateIds.findIndex(id => id === uid)

			Vue.delete(state.templateIds, idx)
			Vue.delete(state.projectsById, uid)
		},

		clear: (state) => {
			state.templateIds = []
			state.projectsById = {}
		}
	}
}

export default module
